var _circle, _path, _path2, _circle2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2926,
    r: 25,
    fill: "#64DD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 24.1138L16.8956 30.4536L16.8956 17.774L27.8765 24.1138Z",
    fill: "#64DD17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7727 10.2926L19.5908 27.4744L13.2272 21.1108L6.81812 27.5199L19.5908 40.2926L43.1818 16.7017L36.7727 10.2926Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2926,
    r: 25,
    fill: "#64DD17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8765 24.1138L16.8956 30.4536L16.8956 17.774L27.8765 24.1138Z",
    fill: "#64DD17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.0927L9.60005 24.6927L6.80005 27.4927L18 38.6927L42 14.6927L39.2001 11.8927L18 33.0927Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.baefafe1fdc1b4379107124787c53056.svg";
export { ForwardRef as ReactComponent };